import { Component, OnDestroy, OnInit } from '@angular/core';
import { alCambiarDescargas } from 'src/app/utils/descargas-en-curso';

/**
 * Cinta flotante con lo que se está preparando para descargar (Mario, 4-nov: «al descargar archivos no se muestra
 * un loading»). Se monta UNA vez en la raíz, así cubre todas las pantallas y no se pierde al cambiar de pantalla.
 * La lógica vive en utils/descargas-en-curso.ts; aquí solo se pinta. Sin descargas no pinta nada.
 */
@Component({
  selector: 'app-descargas-en-curso',
  templateUrl: './descargas-en-curso.component.html',
  styleUrls: ['./descargas-en-curso.component.css'],
})
export class DescargasEnCursoComponent implements OnInit, OnDestroy {
  descargas: { clave: string; texto: string }[] = [];
  private baja: () => void = () => {};

  ngOnInit(): void { this.baja = alCambiarDescargas((l: { clave: string; texto: string }[]) => (this.descargas = l)); }
  ngOnDestroy(): void { this.baja(); }
  trackClave = (_: number, d: { clave: string }) => d.clave;
}
